
import Popup from 'vux/src/components/popup/index.vue'
import Qrcode from 'vux/src/components/qrcode/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

import {urlConfig} from '@/api/urlConfig';
import {fetch, promptMessage, baseUrl } from '@/api/dataHandling';
import {getken} from '@/api/getToken'
export default {
data(){
return{
applictionNo:'',
diagItemCname:'',
hospitalAreaName:'',
identityNo:'',
orderedDate:'',
patientName:'',
sjfztCmc:'',
totalAmt:'',
}
},
directives: {
TransferDom
},
components: {
Popup, Qrcode, Cell, Checker, CheckerItem, Checklist, Toast, Icon, Grid, GridItem, GroupTitle, Flexbox, FlexboxItem, Datetime, XTextarea, XInput, XHeader, Radio, XButton, Group, PopupRadio
},
methods:{
getmsg(){
fetch('post',urlConfig.nucleicAcidInfo+'?applicationNo='+this.$route.query.applicationNo).then(response => {   //获取院区
console.log(response,7)
this.applictionNo = response.applictionNo;
this.diagItemCname = response.diagItemCname;
this.hospitalAreaName = response.hospitalAreaName;
this.identityNo = response.identityNo;
this.orderedDate = response.orderedDate;
this.patientName = response.patientName;
this.sjfztCmc = response.sjfztCmc;
this.totalAmt = response.totalAmt;
this.$store.commit('updateLoadingStatus', {isLoading: false})
}).catch(error => {

});
},
sureClick(){
this.$store.commit('updateLoadingStatus', {isLoading: true})
if(this.totalAmt != 0){    // 不是免费项目
this.timestamp = Date.parse(new Date());
if(this.$route.query.hosCode=='510100000008'){
this.location="sgtszzx";
}else{
this.location="scvif";
}

window.location.href = "http://app.cdxt.com.cn/"+this.location+"/pages/payMain.html?t="+this.timestamp;
}else{
fetch('post',urlConfig.freenucleicAcidSave,{applicationNo:this.$route.query.applicationNo,personInfoId:this.$route.query.personInfoId}).then(response => {
promptMessage('提示','缴费成功！');
window.location.reload();
this.$store.commit('updateLoadingStatus', {isLoading: false})
}).catch(error => {

});
}

}
},
mounted() {
this.$store.commit('updateLoadingStatus', {isLoading: true})
getken(this.getmsg)
}
}



// WEBPACK FOOTER //
// ./src/project/selfHelpFilingProject/nucleicAcidDetail.vue